import { useSEO } from "../hooks/useSEO";
import { CONTACT_EMAIL, INSTAGRAM_URL } from "../config/brand";

const CONTENT = {
  contact: {
    title: "CONTACT",
    body: (
      <>
        <p>
          For orders, sizing and general enquiries, reach us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="underline underline-offset-2">
            {CONTACT_EMAIL}
          </a>
          .
        </p>
        <p className="mt-4">
          Instagram:{" "}
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">
            @richkidsfuneral
          </a>
        </p>
        <p className="mt-4 text-black/50">Customer support replies within 1–2 business days.</p>
      </>
    ),
  },
  shipping: {
    title: "SHIPPING",
    body: (
      <>
        <p>Orders are dispatched within 3–5 business days. Worldwide shipping available.</p>
        <p className="mt-4">Free shipping on orders over Rs. 20,000. A flat Rs. 500 rate applies below that.</p>
        <p className="mt-4 text-black/50">
          Final shipping terms, rates and delivery windows will be published here.
        </p>
      </>
    ),
  },
  returns: {
    title: "RETURNS",
    body: (
      <>
        <p>Returns are accepted within 14 days of delivery on unworn items with tags attached.</p>
        <p className="mt-4 text-black/50">
          Final returns policy will be published here.
        </p>
      </>
    ),
  },
  privacy: {
    title: "PRIVACY",
    body: (
      <p className="text-black/50">
        The RICH KIDS FUNERAL privacy policy will be published here.
      </p>
    ),
  },
  terms: {
    title: "TERMS",
    body: (
      <p className="text-black/50">
        The RICH KIDS FUNERAL terms of service will be published here.
      </p>
    ),
  },
};

export default function StaticPage({ page }) {
  const c = CONTENT[page];
  useSEO(`${c.title} — RICH KIDS FUNERAL`, `RICH KIDS FUNERAL — ${c.title.toLowerCase()}.`);

  return (
    <div className="px-4 md:px-6 pt-16 md:pt-24 max-w-2xl mx-auto" data-testid={`static-page-${page}`}>
      <h1 className="font-anton-sc text-2xl md:text-4xl tracking-[0.08em]">{c.title}</h1>
      <div className="text-sm leading-relaxed mt-8">{c.body}</div>
    </div>
  );
}
